import { IModalService } from "angular-ui-bootstrap";

export interface IBadgesModals {
  openAwardDialog(param: { badgeId?: string; assigneeId?: string }): void;
  openBadgeDialog(assignmentId: string): void;
}

export class BadgesModalsService implements IBadgesModals {
  public static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  public openAwardDialog(param: { badgeId?: string; assigneeId?: string }): void {
    const { badgeId, assigneeId } = param;

    this.$uibModal.open({
      templateUrl: require("../views/award.jade"),
      backdrop: false,
      windowClass: "modal-large award-badge",
      backdropClass: "dark-backdrop",
      controller: "AwardBadgeCtrl",
      resolve: {
        badgeId: () => {
          return badgeId || "";
        },
        assigneeId: () => {
          return assigneeId || "";
        },
      },
    });
  }

  public openBadgeDialog(assignmentId: string): void {
    this.$uibModal.open({
      templateUrl: require("../views/badge.jade"),
      backdrop: false,
      windowClass: "single-badge-preview medium",
      controller: "BadgeCtrl",
      resolve: {
        badgeAssignmentId: () => {
          return assignmentId;
        },
      },
    });
  }
}
